module.exports = __webpack_public_path__ + "img/cbs.4a1492fa.svg";